import { Box, Card, Grid, Skeleton, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

const CARD_COUNT = 4;

export const MattersListSkeleton = () => (
  <MattersListGrid
    container
    spacing={2}
    aria-busy="true"
    aria-label="Loading matters"
  >
    {Array.from({ length: CARD_COUNT }).map((_, index) => (
      <Grid size={12} key={index}>
        <SkeletonCard variant="outlined">
          <Stack direction="row" alignItems="flex-start" spacing={2}>
            <SkeletonAvatar variant="circular" />
            <MatterContentBox>
              <SkeletonTitle variant="text" width="60%" height={28} />
              <Skeleton variant="text" width="40%" height={20} />
              <SkeletonSubtext variant="text" width="80%" height={20} />
            </MatterContentBox>
          </Stack>
        </SkeletonCard>
      </Grid>
    ))}
  </MattersListGrid>
);

const MattersListGrid = styled(Grid)({});

const SkeletonCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(2),
}));

const MatterContentBox = styled(Box)({
  flex: 1,
  minWidth: 0,
});

const SkeletonAvatar = styled(Skeleton)({
  width: 40,
  height: 40,
});

const SkeletonTitle = styled(Skeleton)(({ theme }) => ({
  marginBottom: theme.spacing(1),
}));

const SkeletonSubtext = styled(Skeleton)(({ theme }) => ({
  marginBottom: theme.spacing(1),
}));
